var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStarOutine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON STARS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "STARS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4026 16.2434C16.827 15.8191 17.5149 15.8191 17.9392 16.2434L30.1864 28.4906C30.6107 28.9149 30.6107 29.6028 30.1864 30.0271C29.762 30.4515 29.0741 30.4515 28.6498 30.0271L16.4026 17.78C15.9783 17.3557 15.9783 16.6677 16.4026 16.2434Z",
    fill: "#EF7056",
    stroke: "#EF7056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.4026 28.4871L28.6498 16.2399C29.0741 15.8156 29.762 15.8156 30.1864 16.2399C30.6107 16.6643 30.6107 17.3522 30.1864 17.7765L17.9392 30.0237C17.5149 30.448 16.827 30.448 16.4026 30.0237C15.9783 29.5993 15.9783 28.9114 16.4026 28.4871Z",
    fill: "#EF7056",
    stroke: "#EF7056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.6363 22.0452H31.9564C32.5565 22.0452 33.0429 22.5316 33.0429 23.1317C33.0429 23.7318 32.5565 24.2182 31.9564 24.2182H14.6363C14.0363 24.2182 13.5498 23.7318 13.5498 23.1317C13.5498 22.5316 14.0363 22.0452 14.6363 22.0452Z",
    fill: "#EF7056",
    stroke: "#EF7056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.2936 13.3877C23.8936 13.3877 24.3801 13.8742 24.3801 14.4742V31.7943C24.3801 32.3944 23.8936 32.8808 23.2936 32.8808C22.6935 32.8808 22.207 32.3944 22.207 31.7943V14.4742C22.207 13.8742 22.6935 13.3877 23.2936 13.3877Z",
    fill: "#EF7056",
    stroke: "#EF7056"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23 44C34.598 44 44 34.598 44 23C44 11.402 34.598 2 23 2C11.402 2 2 11.402 2 23C2 34.598 11.402 44 23 44Z",
    stroke: "#EF7056",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarOutine);
export default __webpack_public_path__ + "static/media/icon-star-outine.96f668317e28f936fe046554a6784d37.svg";
export { ForwardRef as ReactComponent };